import React, { useRef, useState } from "react";
import { toast } from "react-toastify";

function MakeOfferFormTwo({ props }) {
  const [agree, setAgree] = useState(false);
  const [name, setName] = useState("");
  const [size, setSize] = useState("");
  const fileRef = useRef(null);
  const [aqdasYes, setAqdasYes] = useState("yes");
  const handleChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      props.setPdf(file);
      console.log(file);
      setName(file.name);
      setSize((file.size / 1000000).toFixed(2));
    }
  };
  const handleUploadClick = () => {
    fileRef.current.click();
  };
  const removePdf = () => {
    props.setPdf(null);
    setName("");
    fileRef.current.value = null; // Clear the file input
  };

  const handleContinue = () => {
    if (props.bankContractPdf) {
      if (props.bankContractPdf.size / 2000000 > 1) {
        toast.error("File should be less than 2 MB");
      } else {
        props.setIndex(3);
      }
    } else {
      toast.error("Please Upload File");
    }
  };
  const handleContinue2 = () => {
    props.setIndex(3);
  };
  return (
    <>
      <form className="agent-register-form">
        <p className="schedule-tour-span">
          Would you like expert assistance with financing?
        </p>
        <div className="schedule-tour-pdf-container">
          <div
            role="button"
            onClick={() => setAqdasYes("yes")}
            className={`make-offer-yes-no-card ${aqdasYes === "yes" ? "make-offer-yes-no-card-active" : ""}`}
          >
            Yes
          </div>
          <div
            role="button"
            onClick={() => setAqdasYes("no")}
            className={`make-offer-yes-no-card ${aqdasYes === "no" ? "make-offer-yes-no-card-active" : ""}`}
          >
            No
          </div>
        </div>

        {aqdasYes === "no" ? (
          <>
            <p className="schedule-tour-span">
              If you are approved for a loan please upload pre-approval
            </p>

            <div className="schedule-tour-pdf-container">
              {props.bankContractPdf ? (
                <div className="schedule-tour-pdf-card">
                  <img
                    src="/img/pdf-preview.svg"
                    className="img-fluid"
                    alt=""
                  />
                  <span
                    style={{
                      color: "#ffffff",
                      fontFamily: "Degular-Light",
                      opacity: "0.7",
                    }}
                  >
                    {name.slice(0, 5)}.pdf ({size}mb)
                  </span>
                  <span
                    onClick={removePdf}
                    role="button"
                    className="badge rounded-circle text-bg-light pdf-close"
                  >
                    X
                  </span>
                </div>
              ) : (
                <>
                  <div
                    role="button"
                    onClick={handleUploadClick}
                    className="schedule-tour-pdf-card"
                  >
                    <img
                      src="/img/plus-upload.svg"
                      className="img-fluid"
                      alt=""
                    />
                    <span
                      style={{
                        color: "#ffffff",
                        fontFamily: "Degular-Light",
                        opacity: "0.7",
                      }}
                    >
                      Upload PDF
                    </span>
                  </div>
                </>
              )}

              <input
                ref={fileRef}
                hidden
                type="file"
                accept=".pdf"
                onChange={handleChange}
              />
            </div>

            <p className="schedule-tour-span">
              If you are not approved please skip this part.
            </p>
            {/* <p className="schedule-tour-span">
              Would you like to tour the property?
            </p>
            <div className="schedule-tour-pdf-container">
              <div
                role="button"
                onClick={() => props.setYesNo("yes")}
                className={`make-offer-yes-no-card ${props.yesOrNo === "yes" ? "make-offer-yes-no-card-active" : ""}`}
              >
                Yes
              </div>
              <div
                role="button"
                onClick={() => props.setYesNo("no")}
                className={`make-offer-yes-no-card ${props.yesOrNo === "no" ? "make-offer-yes-no-card-active" : ""}`}
              >
                No
              </div>
            </div> */}
            {/* <div className="mb-3 form-check agent-register-verify-check-group px-0">
          <img
            role="button"
            onClick={() => setAgree(!agree)}
            src={`${agree ? "/img/checked.svg" : "/img/uncheck.svg"}`}
            className="img-fluid"
            alt=""
          />

          <label className="form-check-label ms-3" htmlFor="exampleCheck1">
            I would also like to see other financing options
          </label>
        </div> */}
            <span
              onClick={handleContinue}
              className="btn agent-register-button"
            >
              Continue
            </span>
            <span
              onClick={() => props.setIndex(3)}
              className="btn schedule-tour-skip-button"
            >
              Skip
            </span>
          </>
        ) : (
          <>
            {/* <p className="schedule-tour-span">
              Would you like to tour the property?
            </p>
            <div className="schedule-tour-pdf-container">
              <div
                role="button"
                onClick={() => props.setYesNo("yes")}
                className={`make-offer-yes-no-card ${props.yesOrNo === "yes" ? "make-offer-yes-no-card-active" : ""}`}
              >
                Yes
              </div>
              <div
                role="button"
                onClick={() => props.setYesNo("no")}
                className={`make-offer-yes-no-card ${props.yesOrNo === "no" ? "make-offer-yes-no-card-active" : ""}`}
              >
                No
              </div>
            </div> */}
            <span
              onClick={handleContinue2}
              className="btn agent-register-button"
            >
              Continue
            </span>
          </>
        )}
      </form>
    </>
  );
}

export default MakeOfferFormTwo;
